import getItemIdForReportIssue from '../view/getItemIdForReportIssue';
import isEmailDonationSupported from '../featureChecks/isEmailDonationSupported';
import populateUserVoiceData from '../telemetry/populateUserVoiceData';
import { reportIssue, sendNegativeFeedback } from '../../services/userVoiceReports';
import { TxpObject, TxpDatapoint } from 'txp-data';
import populateFeedbackDataPoint from '../../utils/telemetry/populateFeedbackDataPoint';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';
import getOriginFromTxpObject from '../view/getOriginFromTxpObject';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import isInferencesDSATSupported from '../featureChecks/isInferencesDSATSupported';
import getInferredEntityIds from './getInferredEntityIds';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';

/**
 * Telemetry callback when 'report issue' clicked with feedbackDataPoint
 */
export default function onReportIssueHandler(
    feedbackType: string,
    feedbackLocationName: string,
    onFeedbackClicked: (txpDatapoint: TxpDatapoint, datapointName: string) => void,
    txpObject: TxpObject,
    txpStatus: TxpStatus,
    itemId: string,
    internetMessageId: string,
    entityNamesMap: number,
    txpConfiguration: TxpConfiguration
) {
    itemId = getItemIdForReportIssue(txpObject, itemId);
    const origin = getOriginFromTxpObject(txpObject);
    const isInferencesDSAT: boolean = isInferencesDSATSupported();
    let userVoiceData = populateUserVoiceData(
        txpObject,
        txpStatus,
        entityNamesMap,
        feedbackLocationName,
        internetMessageId,
        origin,
        isInferencesDSAT
    );

    const inferredEntityIds = isInferencesDSAT ? getInferredEntityIds(txpObject) : null;

    if (isEmailDonationSupported()) {
        reportIssue(userVoiceData, itemId, inferredEntityIds);
    } else {
        sendNegativeFeedback(userVoiceData);
    }

    if (onFeedbackClicked) {
        const dataPoint = populateFeedbackDataPoint(
            feedbackType,
            entityNamesMap,
            origin,
            txpStatus,
            txpConfiguration
        );
        onFeedbackClicked(dataPoint, TxpDataPointNames.TXPUserVoice);
    }
}
